/*
  BCo PDP updates (loaded BEFORE product-info.js so it runs before the theme builds the gallery slider)
  1) On load, pre-select a Color and the first Width so size availability shows right away.
     Color = the one in a ?variant= link, else ?color=<Color> (from collection cards), else the first color.
  2) The gallery only shows the selected colorway's images (on load and whenever a Color is picked).
     Image -> color matching (from the page itself, no extra request): image alt text equal to the color name wins;
     otherwise the color name is matched against the image file name / alt (e.g. "Multicam" also matches "camo").
     Images that match no color are shared and shown for every color.
*/
(function () {
  if (window.__bcoPdpVariantDefaults) return;
  window.__bcoPdpVariantDefaults = true;

  var COLOR_NAME = /^options\[[^\]]*colou?r[^\]]*\]$/i;
  var WIDTH_NAME = /^options\[[^\]]*width[^\]]*\]$/i;
  var ALIASES = { multicam: ['camo'], 'ranger green': ['rangegreen'] };

  function reveal() { document.documentElement.classList.remove('bco-color-pending'); }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  function tokensFor(color) {
    var lc = String(color).toLowerCase().trim();
    var t = [norm(lc)];
    lc.split(/[\s\-\/]+/).forEach(function (w) { if (w.length >= 4) t.push(norm(w)); });
    (ALIASES[lc] || []).forEach(function (a) { t.push(norm(a)); });
    return t.filter(function (x, i, a) { return x && a.indexOf(x) === i; });
  }

  function fileName(src) { return String(src || '').split('?')[0].split('/').pop(); }

  function optionInputs(pi, re) {
    return toArray(pi.querySelectorAll('input[data-single-option-selector]')).filter(function (i) { return re.test(i.name); });
  }

  function urlColor() {
    var m = /[?&]color=([^&#]*)/.exec(window.location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')).toLowerCase().trim() : '';
  }

  /* ---------- Gallery ---------- */
  function Gallery(pi, colors) {
    this.pi = pi;
    this.slider = pi.querySelector('[data-product-single-media-slider]');
    this.thumbs = pi.querySelector('[data-product-single-media-thumbs]');
    this.slides = this.slider ? toArray(this.slider.querySelectorAll('[data-product-slide]')) : [];
    this.thumbEls = this.thumbs ? toArray(this.thumbs.querySelectorAll('[data-thumbnail-id]')) : [];
    this.thumbParent = this.thumbEls.length ? this.thumbEls[0].parentElement : null;
    this.current = null;
    this.map = {};
    this.shared = {};
    this.enabled = false;
    this.build(colors);
  }

  Gallery.prototype.build = function (colors) {
    var self = this;
    colors.forEach(function (c) { self.map[c] = {}; });
    this.slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      var id = String(slide.dataset.id);
      var alt = norm(img && img.getAttribute('alt'));
      var hay = norm(fileName(img && (img.getAttribute('src') || img.currentSrc))) + ' ' + alt;
      var best = null, bestScore = 0, tie = false;
      colors.forEach(function (c) {
        var score = 0;
        if (alt && alt === norm(c)) score = 1000;
        else tokensFor(c).forEach(function (tok) { if (hay.indexOf(tok) > -1 && tok.length > score) score = tok.length; });
        if (score > bestScore) { best = c; bestScore = score; tie = false; }
        else if (score && score === bestScore) tie = true;
      });
      if (best && !tie) { self.map[best][id] = true; self.enabled = true; }
      else self.shared[id] = true;
    });
  };

  Gallery.prototype.keepFn = function (color) {
    var own = this.map[color];
    if (!this.enabled || !own || !Object.keys(own).length) return function () { return true; };
    var shared = this.shared;
    return function (el) { var id = String(el.dataset.id); return !!(own[id] || shared[id]); };
  };

  // Before the theme builds the slider: trim the DOM so the slider is created with only this color's images.
  Gallery.prototype.applyBeforeInit = function (color) {
    if (!this.slider || !this.slides.length) return;
    this.current = color;
    var keep = this.keepFn(color);
    var slides = this.slides.filter(keep);
    if (!slides.length) return;
    var thumbs = this.thumbEls.filter(keep);
    var self = this;
    this.slides.forEach(function (el) { if (slides.indexOf(el) < 0 && el.parentElement) el.parentElement.removeChild(el); });
    this.thumbEls.forEach(function (el) { if (thumbs.indexOf(el) < 0 && el.parentElement) el.parentElement.removeChild(el); });
    slides.forEach(function (el, i) { el.classList.toggle('media--hidden', i !== 0); });
    thumbs.forEach(function (el, i) {
      el.classList.toggle('is-selected', i === 0);
      el.classList.toggle('is-nav-selected', i === 0);
    });
    var img = slides[0].querySelector('img');
    if (img) { img.setAttribute('loading', 'eager'); img.setAttribute('fetchpriority', 'high'); }
    void self;
  };

  // After the theme is running (shopper picks another color).
  Gallery.prototype.apply = function (color) {
    if (!this.slider || !this.slides.length || color === this.current) return;
    this.current = color;
    var keep = this.keepFn(color);
    var slides = this.slides.filter(keep);
    var thumbs = this.thumbEls.filter(keep);
    if (!slides.length) { slides = this.slides; thumbs = this.thumbEls; }
    slides.forEach(function (el) { var img = el.querySelector('img'); if (img) img.setAttribute('loading', 'eager'); });

    var Flk = window.theme && window.theme.Flickity;
    var flkty = Flk && Flk.data(this.slider);
    var nav = Flk && this.thumbs && Flk.data(this.thumbs);

    if (flkty && flkty.isActive) {
      flkty.remove(flkty.cells.map(function (c) { return c.element; }));
      flkty.append(slides);
      if (nav && nav.isActive) {
        nav.remove(nav.cells.map(function (c) { return c.element; }));
        nav.append(thumbs);
      }
      flkty.select(0, false, true);
      if (nav && nav.isActive) nav.select(0, false, true);
      flkty.resize();
    } else {
      var slider = this.slider;
      this.slides.forEach(function (el) { if (slides.indexOf(el) > -1) slider.appendChild(el); else if (el.parentElement) el.parentElement.removeChild(el); });
      var tp = (this.thumbs && this.thumbs.querySelector('.flickity-slider')) || this.thumbParent;
      if (tp) this.thumbEls.forEach(function (el) { if (thumbs.indexOf(el) > -1) tp.appendChild(el); else if (el.parentElement) el.parentElement.removeChild(el); });
    }

    var first = slides[0];
    if (first && typeof this.pi.switchMedia === 'function' && first.dataset.mediaId) {
      try { this.pi.switchMedia(first.dataset.mediaId); } catch (e) {}
    } else if (first) {
      slides.forEach(function (el) { el.classList.toggle('media--hidden', el !== first); });
    }
  };

  /* ---------- Per product ---------- */
  function prepare(pi) {
    if (pi.__bcoInit) return null;
    pi.__bcoInit = true;

    var colorInputs = optionInputs(pi, COLOR_NAME);
    var widthInputs = optionInputs(pi, WIDTH_NAME);
    var checkedColor = colorInputs.filter(function (i) { return i.checked; })[0];
    var checkedWidth = widthInputs.filter(function (i) { return i.checked; })[0];
    var want = urlColor();
    var paramColor = want && colorInputs.filter(function (i) { return String(i.value).toLowerCase().trim() === want; })[0];

    // 1) default selection, set directly before the theme initialises (no request, no re-render)
    var colorPick = checkedColor || paramColor || colorInputs[0];
    var widthPick = checkedWidth || widthInputs[0];
    if (colorPick) colorPick.checked = true;
    if (widthPick) widthPick.checked = true;

    // 2) gallery for that color
    var gallery = null;
    if (colorInputs.length) {
      gallery = new Gallery(pi, colorInputs.map(function (i) { return i.value; }));
      if (colorPick) gallery.applyBeforeInit(colorPick.value);
    }
    return { pi: pi, gallery: gallery, colorInputs: colorInputs };
  }

  function wire(state) {
    var pi = state.pi, gallery = state.gallery;
    pi.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('input[data-single-option-selector]')) return;
      if (gallery && COLOR_NAME.test(t.name) && t.checked) gallery.apply(t.value);
      // keep size availability in step with the chosen color/width
      if (typeof pi.updateCustomOptionAvailability === 'function') {
        setTimeout(function () { try { pi.updateCustomOptionAvailability(); } catch (err) {} }, 0);
      }
    });
    if (gallery) {
      var t;
      window.addEventListener('theme:resize:width', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var c = gallery.current; gallery.current = null; if (c) gallery.apply(c);
        }, 300);
      });
    }
  }

  function start() {
    var states = [];
    try {
      toArray(document.querySelectorAll('product-info[id^="MainProduct"]')).forEach(function (pi) {
        var s = prepare(pi);
        if (s) states.push(s);
      });
    } catch (e) { console.warn('[BCo PDP] prepare failed', e); }
    reveal();
    var go = function () { states.forEach(wire); };
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('product-info').then(go);
    else go();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
